export default __webpack_public_path__ + "static/stamart-c77ebff53932ff217347885d2d038402.png";